import { type FC, type ReactNode } from "react";

import { css } from "@emotion/css";

interface LoadingContainerProps {
    loading: boolean;
    children?: ReactNode;
}

const disabledContainer = css`
    pointer-events: none;
    opacity: 0.5;
`;

export const LoadingContainer: FC<LoadingContainerProps> = ({ children, loading }) => {
    let containerClass = "";
    if (loading) {
        containerClass = disabledContainer;
    }
    return <div className={containerClass}>{children}</div>;
};
